import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { CLIENT_COMMENT_LABELS } from '~/components/CommentCell/constants.ts';
import { commentCellStyles } from '~/components/CommentCell/styles.ts';
import { getCommentPlainText } from '~/components/CommentCell/utils.ts';

interface IClientCommentDialogProps {
  initialComment?: string;
  open: boolean;
  onClose: () => void;
}

export const ClientCommentDialog: React.FC<IClientCommentDialogProps> = ({
  initialComment,
  open,
  onClose,
}) => {
  const commentText = getCommentPlainText(initialComment);

  return (
    <Dialog open={open} onClose={onClose} sx={commentCellStyles.clientDialog}>
      <Box sx={commentCellStyles.clientDialogHeader}>
        <Typography component="h2" sx={commentCellStyles.clientDialogTitle}>
          {CLIENT_COMMENT_LABELS.dialogTitle}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={commentCellStyles.clientDialogCloseIcon}
          aria-label={CLIENT_COMMENT_LABELS.closeAria}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={commentCellStyles.clientDialogContent}>
        <Typography sx={commentCellStyles.clientDialogText}>{commentText}</Typography>
      </DialogContent>

      <DialogActions sx={commentCellStyles.clientDialogActions}>
        <Button variant="contained" onClick={onClose} sx={commentCellStyles.clientCloseButton}>
          {CLIENT_COMMENT_LABELS.close}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
